import React, { useState, useEffect } from 'react'
import { toast, ToastContainer } from 'react-toastify'
import { getAllRoomSvc, saveTchRoomSvc, removeTchRoomSvc, removeAllTchSvc } from './displayPlanSvc'

function TchRoomsSlide(props) {
  const [id, setId] = useState(0)
  const [roomId, setRoomId] = useState(0)
  const [lstRoom, setLstRoom] = useState([])
  const [found, setFound] = useState([])
  const [tch, setTch] = useState('')
  const [room, setRoom] = useState('')
  const [floor, setFloor] = useState('')
  const [lstPtmRoom, setLstPtmRoom] = useState([])

  useEffect(() => {
    getAllRoomSvc(cbAllRoom)
    setLstPtmRoom(props.lstPtmRoom)
    setFound(props.lstPtmRoom)
  }, [props.lstPtmRoom])

  const cbAllRoom = (data) => {
    if (data.status == "Success") {
      setLstRoom(data.lstRoom)
    } else {
      toast.error(data.message)
    }
  }

  const setTchRoom = (pObj, pVal) => {
    if (pVal == "Rooms") {
      removeTchRoomSvc(pObj.tchRoomId, cbSaveTchRoom);
      return;
    }
    saveTchRoomSvc(pObj.tchRoomId, pObj.tchId, pVal, cbSaveTchRoom)
  }

  const cbSaveTchRoom = (data) => {
    if (data.status == "Success") {
      toast.success(data.message)
      props.getTchRoomList()
    } else {
      toast.error(data.message)
    }
  }

  const removeAllTch = () => {
    removeAllTchSvc(cbSaveTchRoom);
  }

  const filterTch = e => {
    const keyword = e.target.value
    if (keyword !== '') {
      const results = found.filter(obj => {
        return obj.tch.toLowerCase().includes(keyword.toLowerCase())
        // Use the toLowerCase() method to make it case-insensitive
      })
      setFound(results)
    } else {
      setFound(lstPtmRoom)
      // If the text field is empty, show all users
    }

    setTch(keyword)
  }
  const filterRoom = e => {
    const keyword = e.target.value
    if (keyword !== '') {
      const results = found.filter(obj => {
        return obj.room.toLowerCase().includes(keyword.toLowerCase())
        // Use the toLowerCase() method to make it case-insensitive
      })
      setFound(results)
    } else {
      setFound(lstPtmRoom)
      // If the text field is empty, show all users
    }

    setRoom(keyword)
  }

  const filterFloor = e => {
    const keyword = e.target.value
    if (keyword !== '') {
      const results = found.filter(obj => {
        return obj.floor.toLowerCase().includes(keyword.toLowerCase())
        // Use the toLowerCase() method to make it case-insensitive
      })
      setFound(results)
    } else {
      setFound(lstPtmRoom)
      // If the text field is empty, show all users
    }
    setFloor(keyword)
  }

  const colgrp = (
    <colgroup>
      <col width='40' />
      <col width='40' />
      <col width='20' />
    </colgroup>
  )

  return (
    <div className='col-sm-10 col-centered'>
      <div className="pull-right">
        <button className="btn btn-info" title="Remove All" onClick={() => removeAllTch()}>Remove All</button>
      </div>
      <div className="row">
        <table className='tableLayout1'>
          {colgrp}
          <thead>
            <tr>
              <th className='padding-remove' >
                <input
                  onChange={filterTch}
                  type='text'
                  value={tch}
                  className='form-control inp-search'
                  placeholder='Teacher'
                />
              </th>
              <th className='text-center'>
                <input
                  onChange={filterRoom}
                  type='text'
                  value={room}
                  className='form-control inp-search'
                  placeholder='Room'
                />
              </th>
              <th className='text-center'>
                <input
                  onChange={filterFloor}
                  type='text'
                  value={floor}
                  className='form-control inp-search'
                  placeholder='Floor'
                />
              </th>
            </tr>
          </thead>
        </table>
        <div className='tablebodyWrapper'>
          <table className='tableLayout'>
            {colgrp}
            <tbody>
              {found && found.length && found.map((obj, idx) => {
                return (
                  <tr
                    key={idx}
                    id={idx}
                    obj={JSON.stringify(obj)}
                    className={
                      obj.tchId === id ? 'selected' : ''
                    }
                    onClick={async e => {
                      // console.log(vLstStudent[idx])
                      setId(obj.tchId);
                    }}
                  >
                    <td className='text-center'>
                      {obj.tch}
                    </td>

                    <td className='text-left'>
                      <select className="form-control" value={obj.roomId} onChange={(e) => setTchRoom(obj, e.target.value)}>
                        <option value="Rooms">Rooms</option>
                        {lstRoom.map((obj) => (<option key={obj.roomId} value={obj.roomId}> {obj.room} </option>))}
                      </select>
                    </td>
                    <td className="hidden">{obj.room}</td>
                    <td className='text-center'>
                      {obj.floor}
                    </td>
                  </tr>
                )
              })}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  )
}

export default TchRoomsSlide